import { type ReactNode } from 'react';
import { useAuth } from './AuthContext';

// Compatibility hook for existing consumers; native AuthContext owns the identity.
export function UserProvider({ children }: { children: ReactNode }) { return <>{children}</>; }

export function useUser() {
  const { user, status, session } = useAuth();
  return {
    user,
    loading: status === 'unknown' || status === 'authenticating',
    error: status === 'unavailable' ? 'Authentication is unavailable' : null,
    isFirstLogin: user?.must_change_password || false,
    refreshUser: () => session.refresh(),
    clearUser: () => session.clear(),
  };
}

export const useCurrentUser = () => useUser().user;
export const useIsFirstLogin = () => useUser().isFirstLogin;
